import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { BulkEditBusinessAdapter } from '../adapters/BulkEditBusinessAdapter';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { IBaseBusinessRepository } from '@/coreInfrastructureModule/interfaces/IBaseBusinessRepository';

/**
 * 集計を一括編集するユースケース
 */
export class BulkPutBaseBusinessUseCase {
  private repository: IBaseBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IBaseBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 集計を一括編集する
   * @param targetIds - 対象の集計ID
   * @param info - 更新情報
   * @param nullKeys - NULLにするキー
   */
  public async execute(targetIds: string[], info: Partial<IBusiness>, nullKeys?: string[]): Promise<INetworkResult<void, IError>> {
    try {
      const updateInfos = BulkEditBusinessAdapter.adaptBulkPutBaseBusinessRequestUpdateInfo(info);
      const response = await this.repository.bulkPut(targetIds, updateInfos, nullKeys);

      if (response.status.type === 'success') {
        return {
          status: {
            type: 'success',
            data: undefined,
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: '未知のエラーが発生しました。',
          },
        },
      };
    }
  }
}
